module.exports = __webpack_public_path__ + "static/media/Success.8f71643b.svg";